/* eslint-disable @ok/oklint/no-hardcode-variable */
import { APPLICATION_PAGE_BASE } from '@common/shareholderBenefit';

import { Company } from './types';

export const REGISTER_URL = '/account/register';
export const LOGIN_URL = '/account/login';
export const KYC_URL = '/account/users/verification';

export const getCompanyDest = (company: Company): string =>
  `${APPLICATION_PAGE_BASE}?companyid=${company.id}`;

export const getLoginUrl = (company: Company): string =>
  `${LOGIN_URL}?forward=${encodeURIComponent(getCompanyDest(company))}`;

const getCdnBase = () =>
  `${
    window.okGlobal?.cdnBaseUrl ?? ''
  }/cdn/assets/imgs/shareholderBenefitEntry`;

export const getOkjLogoUrl = () => `${getCdnBase()}/logo.png`;
export const getBgTopImageUrl = () => `${getCdnBase()}/ceiling.png`;
export const getBgBottomImageUrl = () => `${getCdnBase()}/floor.png`;
